<template>
  <confirmation-card content title="Add trip?" :subText="` (${tippingDocket.id})`">
    <template slot="content">
      <div>
        <v-text-field label="Enter a valid trip ID" type="number" v-model="tripId"></v-text-field>
        <v-switch label="Set status to COMPLETED" v-model="complete" color="primary"></v-switch>
      </div>
    </template>
    <v-btn color="grey darken-1" flat @click="close()">Cancel</v-btn>
    <v-btn flat @click="addTrip()" color="primary" :loading="loading">Add Trip</v-btn>
  </confirmation-card>
</template>

<script>
import TippingService from "@/services/requests/tippingService";

export default {
  data() {
    return {
      tripId: null,
      complete: true,
      loading: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    addTrip() {
      if (!this.tripId)
        return this.snack({ text: "Please enter a trip ID", color: "red" });
      if (Number.isNaN(Number(this.tripId)))
        return this.snack({
          text: "Trip ID needs to be a number",
          color: "red"
        });
      var payload = {
        complete: this.complete,
        tippingDocketId: this.tippingDocket.id,
        tripId: this.tripId
      };
      this.loading = true;
      TippingService.addTrip(payload)
        .then(result => {
          this.snack({ text: "Trip ID was recorded!", color: "green" });
          this.$store.state.tipping.fetchTippingDockets = true;
          this.loading = false;
          this.close();
        })
        .catch(err => {
          this.snack({
            text: "There was an error recording the Trip ID",
            color: "red"
          });
          this.loading = false;
        });
    }
  },
  props: {
    tippingDocket: Object
  }
};
</script>

<style>
</style>